import {UserModel} from '@shared/models/user.model';

export class DataMappingSourceOption {
  id: string;
  value: string;
  isChecked: boolean;

  public static getItpFiledDataMappingSourceOption(): DataMappingSourceOption {
    return {
      id: 'itp-fields',
      value: 'ITP Fields',
      isChecked: true
    } as DataMappingSourceOption;
  }

  public static getQuestionnaireFieldDataMappingSourceOption(): DataMappingSourceOption {
    return {
      id: 'questionnaire',
      value: 'Questionnaire',
      isChecked: false
    } as DataMappingSourceOption;
  }
}

export class DataMappingItem {
  name: string;
  sourceName: string;
  sourceType: string;
  sourceFilePath: string;
  targetName: string;
  targetType: string;
  targetFilePath: null;
  createDate: string;
  createdBy: UserModel;
  modifiedDate: string;
  modifiedBy: UserModel;
  id: string;
  type: string;
  fieldValues: {
    [key: string]: any
  };
  displayTexts: any;
  isReadOnly: boolean;
  isDeleted: boolean;
  isArchived: boolean;
  persistanceId: string;
  companyId: string;
  projectId: string;
}

export class ValueMappingContainer {
  type: string;
  fieldValues: {
    [key: string]: any;
  };
}
